document.addEventListener('DOMContentLoaded', function() {
 document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.ais-facets .collapsible-trigger');
    if (!trigger) return;

    const panel = trigger.parentElement.querySelector('.collapsible-content');
    if (!panel) return;

     if (panel.classList.contains('is-open')) {
       panel.classList.remove('is-open');
       trigger.classList.remove('is-open');
       panel.style.height = '0';
     } else {
      panel.style.height = 'auto';
      panel.classList.add('is-open');
      trigger.classList.add('is-open');
    }
  });

  setTimeout(function() {
   const sezzleBtn = document.querySelector(".product-block--price .sezzle-shopify-info-button");
   const policies = document.getElementById("product__policies");

   if (sezzleBtn && policies) {
     policies.insertAdjacentElement("afterend", sezzleBtn);
   }
  }, 1000);


  const original = document.querySelector('.shopify-payment-terms.product__policies .product__policies__inner');
  const target = document.getElementById('product__policies');

 if (original && target) {
   const clone = original.cloneNode(true);
   target.appendChild(clone);
 }

});

 document.addEventListener('keydown', function(event) {
  const form = event.target.closest("form[action='/search']");
  if (!form || event.key !== 'Enter') return;

  const input = form.querySelector("input[name='q']");
  const searchVal = input?.value?.trim() || '';

  if (searchVal.length < 3) {
    event.preventDefault();  
    input.focus();           
    return false;
  }
 });



document.addEventListener('submit', function(event) {
  const form = event.target;

  if (form.matches("form[action='/search']")) {
    const input = form.querySelector("input[name='q']");
    const searchVal = input?.value?.trim() || '';

    if (searchVal.length < 3) {
      event.preventDefault();  
      input?.focus();           
      return false;
    }
  }
});


stampedImageCheck();

function stampedImageCheck() {
  const targetNode = document.getElementById("stamped-main-widget");

  if(targetNode) {
    const config = { attributes: true, childList: true, subtree: true };
    const callback = () => {
      document.querySelectorAll('#stamped-main-widget .stamped-photos-carousel .stamped-photo:not(.lazyfied)').forEach((image)=>{
        let imageEle = image.querySelector('img');
        let src = imageEle.src;
        image.style.background = '';
        src = src.split('?')[0];
        src += '?tr=w-100';
        imageEle.src = src;
        imageEle.loading = 'lazy';
        image.classList.add('lazyfied');
      });
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}

if (document.querySelector('[data-buy-buttons]') && window.innerWidth <= 650) {
  window.addEventListener('scroll', function() {
    const buyButtons = document.querySelector('.product-block [data-buy-buttons]');
    const googleWidget = document.querySelector('#merchantwidget-iframe-wrapper');

    if (buyButtons.classList.contains('product_cart_sticky')) {
      googleWidget.style.bottom = "100px";
    } else {
      googleWidget.style.bottom = "20px";
    }
  });
}


(function () {
  const PAGINATION_KEY = 'stamped-pagination-clicked';
  const SEARCH_KEY = 'stamped-search-value';
  const CLEAR_KEY = 'stamped-clear-clicked';

  document.addEventListener('input', (e) => {
    if (e.target.matches('.stamped-reviews-search-input')) {
      sessionStorage.setItem(SEARCH_KEY, e.target.value.trim());
    }
  }, { passive: true });

  document.addEventListener('keydown', (e) => {
    if (e.target.matches('.stamped-reviews-search-input') && e.key === 'Enter') {
      sessionStorage.setItem(SEARCH_KEY, e.target.value.trim());
    }
  }, { passive: true });

  document.addEventListener('click', (e) => {
    const pageLink = e.target.closest('.stamped-pagination li a');
    const clearBtn  = e.target.closest('.stamped-reviews-search-clear, .stamped-summary-actions-clear');

    if (pageLink) {
      sessionStorage.setItem(PAGINATION_KEY, '1');
      return;
    }

    if (clearBtn) {
      sessionStorage.setItem(CLEAR_KEY, '1');
      sessionStorage.removeItem(SEARCH_KEY);

      const input = document.querySelector('.stamped-reviews-search-input');
      if (input) {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Enter' }));
      }
      hideClearButtons();
    }
  }, { passive: true });

  document.addEventListener('stamped:reviews:loaded', () => {
    const paged = sessionStorage.getItem(PAGINATION_KEY);
    const cleared = sessionStorage.getItem(CLEAR_KEY);
    const saved = (sessionStorage.getItem(SEARCH_KEY) || '').trim();

    if (paged) {
      sessionStorage.removeItem(PAGINATION_KEY);
      scrollToReviews();
    }

    if (cleared) {
      sessionStorage.removeItem(CLEAR_KEY);
      ensureInputBlankThenHide();
      return;
    }
    if (!saved) return;
    restoreSearchValue(saved);
  });

  function restoreSearchValue(value) {
    const stopAt = Date.now() + 2000;
    const attempt = () => {
      const input = document.querySelector('.stamped-reviews-search-input');
      if (!input) return again();

      input.value = value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Enter' }));

      requestAnimationFrame(() => {
        if (input.value.trim() === '') return again();
        showClearButtons();
        scrollToReviews();
      });
    };
    const again = () => { if (Date.now() < stopAt) setTimeout(attempt, 50); };
    attempt();
  }

  function ensureInputBlankThenHide() {
    const stopAt = Date.now() + 2000;
    const attempt = () => {
      const input = document.querySelector('.stamped-reviews-search-input');
      if (!input) return again();
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Enter' }));
      requestAnimationFrame(hideClearButtons);
    };
    const again = () => { if (Date.now() < stopAt) setTimeout(attempt, 50); };
    attempt();
  }

  function hideClearButtons() {
    document.querySelectorAll('.stamped-summary-actions-clear, .stamped-reviews-search-clear')
      .forEach(el => { el.style.display = 'none'; });
  }

  function showClearButtons() {
    document.querySelectorAll('.stamped-summary-actions-clear, .stamped-reviews-search-clear')
      .forEach(el => { el.style.display = 'inline-block'; });
  }

  function scrollToReviews() {
    const el = document.querySelector('.stamped-container, #stamped-main-widget, .stamped-reviews');
    if (el) el.scrollIntoView({ behavior: 'instant', block: 'start' });
  }
})();
